import axios from "axios";
import i18next, { t } from "i18next";
import { toast } from "react-toastify";

import { AuthUserInfo } from "./constants";
import LocalstorageService from "./helpers/localstorage-service";

// Apply base url for axios
// Default to Azure Functions URL if environment variable not set
const API_URL = process.env.REACT_APP_API_URL || "https://atm-backend-api.azurewebsites.net/api";
const axiosApi = axios.create({
  baseURL: API_URL,
});

const ERR_500MSG = t("ERR_500MSG");

axiosApi.interceptors.request.use(
  (config) => {
    const userInfo = LocalstorageService.getItem(AuthUserInfo);
    if (userInfo?.token && !config.url.endsWith("/verify-otp")) {
      config.headers["Authorization"] = `Bearer ${userInfo?.token}`;
    }
    config.headers["i18nLng"] = i18next.resolvedLanguage;
    config.headers["Accept-Language"] =
      i18next.resolvedLanguage === "en" ? "en-US" : "he-IL";
    return config;
  },
  (error) => {
    console.log(">REQ_ERR: ", error?.message);
    toast.error(ERR_500MSG, { toastId: "REQ_ERR" });
    return Promise.reject(error);
  }
);

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(">RES_ERR: ", error?.message);
    if (error?.response?.status === 401) {
      toast.error(t("ERR_TOKEN_EXPIRED"), { toastId: "RES_TOKEN_EXPIRED" });
      LocalstorageService.removeItem(AuthUserInfo);
      window.location.href = "/login";
    } else if (error?.config?.skipErrorToast) {
      // הקורא מטפל בשגיאה בעצמו (מונע double-toast) — לא מציגים את ההודעה הגנרית.
      // דגל config מקומי (לא header) → אינו משפיע על CORS. מאפשר קודי HTTP סמנטיים.
    } else {
      toast.error(ERR_500MSG, { toastId: "RES_ERR" });
    }
    return Promise.reject(error);
  }
);

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config });
}

export async function post(url, data, config = {}) {
  return axiosApi.post(url, { ...data }, { ...config });
}

export async function put(url, data, config = {}) {
  return axiosApi.put(url, { ...data }, { ...config });
}

export async function del(url, config = {}) {
  return await axiosApi.delete(url, { ...config });
}

export async function delPayload(url, data = {}, config = {}) {
  return await axiosApi.delete(url, {
    Authorization: { ...config },
    data: { ...data },
  });
}

export async function postFormData(url, data, config = {}) {
  return axiosApi.post(url, data, {
    "Content-Type": "multipart/form-data",
    ...config,
  });
}

export async function putFormData(url, data, config = {}) {
  return axiosApi.put(url, data, {
    "Content-Type": "multipart/form-data",
    ...config,
  });
}
